import React, { Component } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Legend, Label, LabelList } from 'recharts';

import { PRIMARY_LIGHT, PRIMARY_DARK } from '../constants/colors';

export class BarChartComponent extends Component {
  render() {
    const {
      measurements, width, height, showAxis = false,
    } = this.props;

    return (
      <BarChart
        data={measurements}
        height={height}
        margin={{
          top: 15, right: 0, left: 0, bottom: 15,
        }}
        width={width}
      >
        <XAxis dataKey="name">
          {showAxis &&
            <Label
              offset={0}
              position="insideBottom"
              value="Measurement"
            />
          }
        </XAxis>
        {showAxis ?
          <YAxis label={{ value: 'Retroreflection', angle: -90, position: 'insideLeft' }} /> :
          <YAxis />
        }
        <CartesianGrid strokeDasharray="3 3" />
        <Legend verticalAlign="bottom" />
        <Bar
          dataKey="QD"
          fill={PRIMARY_LIGHT}
        >
          {measurements && measurements.length < 4 ?
            <LabelList
              dataKey="QD"
              position="top"
            /> : null
          }
        </Bar>
        <Bar
          dataKey="RL"
          fill={PRIMARY_DARK}
        >
          {measurements && measurements.length < 4 ?
            <LabelList
              dataKey="RL"
              position="top"
            /> : null
          }
        </Bar>
      </BarChart>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/BarChartComponent.js